import { Box, Tab, Tabs } from "@mui/material";
import { ReactNode, SyntheticEvent, useState } from "react";

import { withForm } from "components/Forms/AppForm";
import { optionAlphaSort } from "utils/sort";

import initialPineFilters from "../../ProductsInEvalTable/schemas/initialPineFilter";
import dateOptions from "../data/dateOptions.json";

import DateFromTo from "./DateFromTo";
import ProgressPointSelect from "./ProgressPointSelect";

const a11yProps = (index: number) => {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
};

// NOTE: STRONG candidate for reusable tabs components
const DateTabs = withForm({
  defaultValues: initialPineFilters,
  render: function Render({ form: pineFilterForm }) {
    const [currentTab, setCurrentTab] = useState(0);

    const handleChange = (_e: SyntheticEvent, value: number) => {
      setCurrentTab(value);
      value === 0 && pineFilterForm.setFieldValue("dynamicDate.field", "");
      value === 1 &&
        pineFilterForm.setFieldValue("dynamicDate.field", "pp_1_estimate");
    };

    return (
      <>
        <Tabs onChange={handleChange} value={currentTab} variant="fullWidth">
          <Tab
            label="Project Dates"
            sx={{ py: 0, fontSize: 12 }}
            {...a11yProps(0)}
          />
          <Tab
            label="Progress Points"
            sx={{ py: 0, fontSize: 12 }}
            {...a11yProps(1)}
          />
        </Tabs>

        {/* Dropdown Dates */}
        <TabPanel index={0} value={currentTab}>
          <pineFilterForm.AppField name="dynamicDate.field">
            {(field) => (
              <field.AutocompleteSelect
                label="Project Date"
                options={dateOptions.sort(optionAlphaSort)}
              />
            )}
          </pineFilterForm.AppField>
        </TabPanel>

        {/* Progress Point Dates */}
        <TabPanel index={1} value={currentTab}>
          <ProgressPointSelect form={pineFilterForm} />
        </TabPanel>

        <DateFromTo form={pineFilterForm}></DateFromTo>
      </>
    );
  },
});
export default DateTabs;

interface TabPanelProps {
  children?: ReactNode;
  index: number;
  value: number;
}

const TabPanel = ({ index, value, children }: TabPanelProps) => {
  if (index !== value) return;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`tab-panel-${index}`}
      aria-labelledby={`tab-${index}`}
    >
      {children}
    </Box>
  );
};
